// src/theme.js
// Extracted from App.jsx — behavior-preserving split (2026-07-20).

import React from "react";

// ═══════ ADMIN / GUEST THEME — Reverse by Reece brand (light, navy-forward) ═══════
// Mirrors the :root tokens in index.css. Navy is the primary/action color,
// clay the warm accent (urgent, active rails), cream/paper the surfaces.
// Brand tokens (navy/cream/clay/etc.) are appended so the sidebar and brand
// marks can reference them directly.
const C={
  bg:"#FAF8F2",surface:"#FFFFFF",surfaceAlt:"#F2EFE7",card:"#FFFFFF",cardHover:"#F2EFE7",
  border:"rgba(11,42,74,0.12)",borderLight:"rgba(11,42,74,0.07)",
  text:"#1A1F2E",textMuted:"#6F7682",textDim:"#9AA1AD",
  accent:"#0B2A4A",accentLight:"#143656",accentDark:"#061A30",accentGlow:"rgba(11,42,74,0.08)",
  green:"#2E9E6B",greenBg:"rgba(46,158,107,0.10)",
  orange:"#D9822B",orangeBg:"rgba(217,130,43,0.10)",
  red:"#D14343",redBg:"rgba(209,67,67,0.08)",
  purple:"#7A5BD0",purpleBg:"rgba(122,91,208,0.10)",
  cyan:"#2C8FA8",
  white:"#FFFFFF",gold:"#B7791F",goldBg:"rgba(183,121,31,0.12)",
  glass:"rgba(250,248,242,0.85)",glassBorder:"rgba(11,42,74,0.10)",
  // brand atoms
  navy:"#0B2A4A",navy2:"#143656",navyDeep:"#061A30",
  cream:"#F2EFE7",cream2:"#E6E0CF",paper:"#FAF8F2",
  blue:"#B8CFE3",blue2:"#7FA3C4",
  clay:"#C97B5C",clayDeep:"#A35B3F",claySoft:"#E8C2AE",
  rule:"rgba(11,42,74,0.12)",
  // Pipeline interest levels (src/interest.js, 10/9/26): the name's colour =
  // how Reece feels about the deal, a yellow highlight = booked. Darker than
  // green / red above so they read at 5:1+ on white AND on the yellow (hover
  // yellow included) — plain C.green is under 3:1 on yellow.
  feelGood:"#146B43",feelFence:"#1F56C9",feelBad:"#B42318",
  booked:"#FFF1A8",bookedHover:"#FBE78C",bookedEdge:"#E2C64A",
};

const Ic={
dash:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></svg>,
pipe:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="4" y1="4" x2="4" y2="20"/><circle cx="4" cy="4" r="2" fill="currentColor"/><circle cx="4" cy="12" r="2" fill="currentColor"/><circle cx="4" cy="20" r="2" fill="currentColor"/><line x1="8" y1="4" x2="20" y2="4"/><line x1="8" y1="12" x2="20" y2="12"/><line x1="8" y1="20" x2="20" y2="20"/></svg>,
auto:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/><circle cx="12" cy="12" r="4"/></svg>,
task:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 11l3 3L22 4"/></svg>,
doc:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
intake:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="9" cy="7" r="4"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>,
calc:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><circle cx="8" cy="10" r=".5" fill="currentColor"/><circle cx="12" cy="10" r=".5" fill="currentColor"/><circle cx="16" cy="10" r=".5" fill="currentColor"/><line x1="8" y1="18" x2="16" y2="18"/></svg>,
send:<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>,
chk:<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>,
warn:<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/></svg>,
clock:<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
search:<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
phone:<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>,
lock:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
bolt:<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
mail:<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
dollar:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>,
mktg:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>,
receipt:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 2v20l3-2 3 2 3-2 3 2 3-2 3 2V2l-3 2-3-2-3 2-3-2-3 2-3-2z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="12" y2="16"/></svg>,
star:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
upload:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3"/></svg>,
book:<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>,
};


// ═══════ ADMIN GATE ═══════
// The admin login form is HIDDEN from the public homepage by default.
// To unlock it, visit the site at this exact path:
//   https://reversebyreece.com/crmadmin
//
// Anyone landing on the homepage without this path sees only public
// content (intake, bio, opt-out, borrower portal) — the admin login
// form isn't rendered, so there's nothing to brute-force or even know
// exists. Bookmark the URL above for yourself.
//
// To rotate the path (e.g. if you suspect it leaked):
//   1. Change the string below to a new value
//   2. Run `vercel --prod` to redeploy
//   3. Update your bookmark
//
// This is OBSCURITY, not encryption. The real auth gates remain Supabase
// Auth + the admin password. The gate just removes the form from the
// public surface so drive-by visitors can't fish for the password.
const ADMIN_PATH = "/crmadmin";
// Max's sign-in path. Same login form as ADMIN_PATH, but it signs in with
// MAX_EMAIL (src/supabase.js). Same obscurity caveat as above.
const MAX_PATH = "/max";

// ═══════ LIGHT THEME ═══════
// Hoisted from BorrowerPortal so the public-facing About / bio page can
// share the same light palette as the borrower portal. Both views import
// it from this single source; if you tweak palette, do it here.
// Borrower portal + public-facing (bio / intake / opt-out) light theme.
// Same Reverse by Reece brand palette as C, tuned for borrower-facing warmth.
const L={
  bg:"#FAF8F2",surface:"#FFFFFF",surfaceAlt:"#F2EFE7",card:"#FFFFFF",
  border:"rgba(11,42,74,0.12)",borderLight:"rgba(11,42,74,0.07)",
  text:"#1A1F2E",textMuted:"#5A6270",textDim:"#9AA1AD",
  accent:"#0B2A4A",accentLight:"#143656",accentDark:"#061A30",accentGlow:"rgba(11,42,74,0.08)",
  green:"#2E9E6B",greenBg:"rgba(46,158,107,0.08)",
  orange:"#D9822B",orangeBg:"rgba(217,130,43,0.08)",
  red:"#D14343",redBg:"rgba(209,67,67,0.06)",
  white:"#FFFFFF",gold:"#B7791F",
  // brand atoms (parity with C)
  navy:"#0B2A4A",navy2:"#143656",navyDeep:"#061A30",
  cream:"#F2EFE7",cream2:"#E6E0CF",paper:"#FAF8F2",
  blue:"#B8CFE3",blue2:"#7FA3C4",
  clay:"#C97B5C",clayDeep:"#A35B3F",claySoft:"#E8C2AE",
  rule:"rgba(11,42,74,0.12)",
};

// ═══════ BRAND ═══════
const BRAND={
  name:"Reverse by Reece",
  company:"Summit Lending",
  tagline:"Reverse by Reece with Summit Lending",
  loNmls:"NMLS #1449852",
  companyNmls:"Company NMLS #1850081",
  azLicense:"AZ Mortgage Broker License #MB1013966",
  nmls:"NMLS #1449852 | Company NMLS #1850081 | AZ MB License #MB1013966",
  nmlsShort:"NMLS #1449852 | Co. NMLS #1850081",
  smsSignature:"Reece | Summit Lending NMLS #1449852",
  licensedStates:"AZ, CA, CO, FL, GA, ID, MT, OR, TN, TX, UT, VA, WA",
  disclaimer:"Licensed in AZ, CA, CO, FL, GA, ID, MT, OR, TN, TX, UT, VA & WA. NMLS #1449852 | Company NMLS #1850081 | AZ Mortgage Broker License #MB1013966. This is not a commitment to lend. All loan programs subject to borrower qualification.",
};

// ═══════ PUBLIC FOOTER / DISCLOSURES — single source of truth ═══════
// Shared by every public-facing footer (direct-mail landing page, /info page)
// so the compliance block can never drift between pages. Edit HERE only.
const PUBLIC_DISCLOSURES={
  contact:{
    name:"Reece Andrews",
    phones:[
      {label:"Office line",num:"480-916-4389",href:"tel:+14809164389"},
      {label:"Cell",num:"302-893-8949",href:"tel:+13028938949"},
    ],
    email:"reece@reversebyreece.com",
    site:"reversebyreece.com",
  },
  // Attribution line rendered above the disclosures.
  attribution:"Reece Andrews, NMLS #1449852 · Summit Lending USA, Company NMLS #1850081",
  hud:"This material is not from HUD or FHA and was not approved by HUD or a government agency. Summit Lending USA is not affiliated with any government agency.",
  nonFhaAge:"Minimum age for non-FHA programs varies by state and lender and is subject to change.",
  obligations:"The borrower must meet all loan obligations, including living in the property as the principal residence, maintaining the home, and paying property taxes and insurance. If these obligations are not met, the loan may become due.",
  // Reece approved this footer as complete (2026-09-08) — no per-state
  // advertising lines on the web footers. If any are ever needed, add each
  // as its own entry here and every public footer renders them automatically.
  stateDisclosures:[],
};

export { C, Ic, ADMIN_PATH, MAX_PATH, L, BRAND, PUBLIC_DISCLOSURES };
